import React, { useContext, useMemo } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { PUBLIC_COMPANIES, PUBLIC_TRANSACTIONS, TRANSACTIONS_COMPS } from 'pages/Valuations/util/constants';
import FutureExitContext from 'pages/ValuationsAllocation/approaches/FutureExit/utils/FutureExitContext';
import { getStringValue } from 'utilities';

const FilteredValuationApproachSelect = (props: any) => {
  const { approaches, isNTMSelected } = useContext(FutureExitContext);
  const { cell } = props;
  const selectedValue = String(cell?.value);
  const availableApproachTypes = useMemo(() => {
    if (isNTMSelected) {
      return [PUBLIC_COMPANIES];
    }
    // I left PUBLIC_TRANSACTIONS and TRANSACTIONS_COMPS just in case they are needed for previously saved approaches
    return [PUBLIC_COMPANIES, PUBLIC_TRANSACTIONS, TRANSACTIONS_COMPS];
  }, [isNTMSelected]);
  const compsList = useMemo(
    () =>
      approaches
        .filter(
          ({ panelId, id, approach_type, valuations_approach_gpc }) =>
            availableApproachTypes.includes(getStringValue(approach_type))
            // Equity-mode public comps have no revenue or EBITDA multiple; one stays listed only while selected.
            && (!valuations_approach_gpc?.is_evaluating_equity_value || String(id ?? panelId) === selectedValue)
        )
        .map(({ panelId, id, name }) => ({
          value: id ?? panelId,
          label: name,
        })),
    [approaches, availableApproachTypes, selectedValue]
  );

  return <GridSelect menuPosition="absolute" options={compsList} {...props} />;
};

export default FilteredValuationApproachSelect;
